import React, { useState } from "react";

import { Link, useNavigate } from "react-router-dom";

import {

  FaTrashAlt,

  FaPlus,

  FaMinus,

  FaShoppingCart,

  FaArrowLeft,

} from "react-icons/fa";

import { toast } from "react-toastify";

import "./Cart.css";

import { getErrorMessage } from "../api/client";

import { useAuth } from "../context/AuthContext";

import { useCart } from "../context/CartContext";

import { resolveAssetUrl } from "../utils/assets";
import Seo from "../components/Seo";
import { PAGE_SEO } from "../constants/seo";
import { CartListSkeleton } from "../components/Skeleton";



const Cart = () => {

  const navigate = useNavigate();

  const { isAuthenticated } = useAuth();

  const { cart, loading, updateQuantity, removeItem } = useCart();

  const [busy, setBusy] = useState(false);



  const handleUpdateQuantity = async (itemId, quantity) => {

    if (quantity < 1) return;

    setBusy(true);

    try {

      await updateQuantity(itemId, quantity);

    } catch (error) {

      toast.error(getErrorMessage(error, "Could not update quantity"));

    } finally {

      setBusy(false);

    }

  };



  const handleRemoveItem = async (itemId) => {

    setBusy(true);

    try {

      await removeItem(itemId);

      toast.success("Item removed");

    } catch (error) {

      toast.error(getErrorMessage(error, "Could not remove item"));

    } finally {

      setBusy(false);

    }

  };



  const proceedToCheckout = () => {

    if (!isAuthenticated) {

      navigate("/login", { state: { from: "/checkout" } });

      return;

    }

    navigate("/checkout");

  };



  if (loading) {
    return (
      <main className="cart-page">
        <Seo {...PAGE_SEO.cart} />
        <section className="cart-hero">
          <span className="cart-badge">
            <FaShoppingCart /> Your Cart
          </span>
          <h1>Review Your Selected Products</h1>
          <p>
            Check your items, update quantities, and proceed to checkout when you
            are ready. Login is required only when placing your order.
          </p>
        </section>
        <section className="cart-section">
          <CartListSkeleton rows={4} />
        </section>
      </main>
    );
  }



  const cartItems = cart.items || [];



  return (

    <main className="cart-page">

      <Seo {...PAGE_SEO.cart} />

      <section className="cart-hero">

        <span className="cart-badge">

          <FaShoppingCart /> Your Cart

        </span>

        <h1>Review Your Selected Products</h1>

        <p>

          Check your items, update quantities, and proceed to checkout when you

          are ready. Login is required only when placing your order.

        </p>

      </section>



      <section className="cart-section">

        {cartItems.length === 0 ? (

          <div className="empty-cart">

            <FaShoppingCart />

            <h2>Your cart is empty</h2>

            <p>Add products to your cart and come back here to review them.</p>

            <Link to="/products" className="continue-btn">

              Continue Shopping

            </Link>

          </div>

        ) : (

          <>

            <div className="cart-items">

              <div className="cart-title-row">

                <h2>Cart Items</h2>

                <span>{cartItems.length} Items</span>

              </div>



              {cartItems.map((item) => (

                <div className="cart-item" key={item.id}>

                  <div className="cart-product">

                    {item.image ? (

                      <img src={resolveAssetUrl(item.image)} alt={item.name} />

                    ) : (

                      <div

                        style={{

                          width: 72,

                          height: 72,

                          background: "#eee",

                          borderRadius: 8,

                        }}

                      />

                    )}



                    <div>

                      <h3>{item.name}</h3>

                      <p>{item.category}</p>

                      {item.selectedAttributes &&

                        Object.keys(item.selectedAttributes).length > 0 && (

                          <p style={{ fontSize: "0.85rem", color: "#666" }}>

                            {Object.entries(item.selectedAttributes)

                              .map(([k, v]) => `${k}: ${v}`)

                              .join(" · ")}

                          </p>

                        )}

                    </div>

                  </div>



                  <div className="cart-price">

                    <span>AED {Number(item.price).toFixed(2)}</span>

                  </div>



                  <div className="quantity-control">

                    <button

                      disabled={busy}

                      onClick={() => handleUpdateQuantity(item.id, item.quantity - 1)}

                    >

                      <FaMinus />

                    </button>



                    <span>{item.quantity}</span>



                    <button

                      disabled={busy}

                      onClick={() => handleUpdateQuantity(item.id, item.quantity + 1)}

                    >

                      <FaPlus />

                    </button>

                  </div>



                  <div className="cart-subtotal">

                    AED {(Number(item.price) * item.quantity).toFixed(2)}

                  </div>



                  <button

                    className="remove-btn"

                    disabled={busy}

                    onClick={() => handleRemoveItem(item.id)}

                  >

                    <FaTrashAlt />

                  </button>

                </div>

              ))}



              <Link to="/products" className="back-shopping">

                <FaArrowLeft /> Continue Shopping

              </Link>

            </div>



            <aside className="cart-summary">

              <h2>Order Summary</h2>



              <div className="summary-row">

                <span>Subtotal</span>

                <strong>AED {Number(cart.subtotal || 0).toFixed(2)}</strong>

              </div>



              <div className="summary-row">

                <span>VAT 5%</span>

                <strong>AED {Number(cart.vatAmount || 0).toFixed(2)}</strong>

              </div>



              <div className="summary-row">

                <span>Delivery</span>

                <strong>To be confirmed</strong>

              </div>



              <div className="summary-total">

                <span>Total</span>

                <strong>AED {Number(cart.total || 0).toFixed(2)}</strong>

              </div>



              <button

                className="checkout-btn"

                disabled={busy}

                onClick={proceedToCheckout}

              >

                {busy ? "Processing..." : "Proceed to Checkout"}

              </button>



              {!isAuthenticated && (

                <p className="summary-note">

                  You can shop as a guest. Log in when you are ready to place your

                  order.

                </p>

              )}



              <p className="summary-note">

                Final delivery and availability can be confirmed by our team.

              </p>

            </aside>

          </>

        )}

      </section>

    </main>

  );

};



export default Cart;

